var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sheet-label-formatted',{staticClass:"simulated-record",class:{
		ghost: _vm.isGhost,
		'cut-right': _vm.endsLaterThanRightBoundary,
		'cut-left': _vm.startersEarlierThanLeftBoundary,
	},style:(_vm.computedStyle),attrs:{"formatting":_vm.labelFormatting}},[_c('r-shadow',{staticClass:"preview",attrs:{"height":1}},[_vm._v("\n\t\t"+_vm._s(_vm.datePreviewText)+"\n\t")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }